import { Code, ConnectError } from '@connectrpc/connect';
/** Plain-language text for a failed seat write. Never the raw server message. */ export function seatErrorMessage(error) {
    const code = error instanceof ConnectError ? error.code : undefined;
    switch(code){
        case Code.Aborted:
            return 'Someone else changed this seat — reload to see the latest.';
        case Code.FailedPrecondition:
            return 'This seat still has people or sub-seats. Move its people and sub-seats to another seat first, then delete it.';
        case Code.PermissionDenied:
            return "You don't have permission to change seats.";
        case Code.NotFound:
            return "This seat couldn't be found, or you don't have access to change it. Reload to see the latest.";
        default:
            return 'Could not save the change. Try again.';
    }
}
